import React from "react";

import { Button, Grid, Modal, Stack, Typography } from "@mui/material";

import MainCard from "../MainCard";
import LoadingButton from "../LoadingButton";

const ConfirmationModal = ({ title, subtitle, onClose, onConfirm, loading }: Props) => {
  return (
    <Modal
      open={true}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description">
      <MainCard sx={{ p: 3 }} modal darkTitle content={false}>
        <Typography variant="h3" sx={{ mb: 3 }}>
          {title}
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Typography variant="h6">{subtitle}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Stack direction="row" spacing={1} justifyContent="end">
              <Button disabled={loading} autoFocus onClick={onClose}>
                Cancel
              </Button>
              <LoadingButton
                loading={loading}
                color="secondary"
                variant="contained"
                onClick={onConfirm}>
                DELETE
              </LoadingButton>
            </Stack>
          </Grid>
        </Grid>
      </MainCard>
    </Modal>
  );
};

export interface Props {
  title: string;
  subtitle: string;
  loading: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export default ConfirmationModal;
